import React, { FC } from 'react';

import { TotalPriceBlockProps } from './totalPriceBlockProps';
import Amount from '../Amount/Amount';
import Discount from '../Discount/Discount';
import NextDate from '../NextDate/NextDate';

import styles from './TotalPriceBlock.module.scss';

const TotalPriceBlock: FC<TotalPriceBlockProps> = ({
  currentPeriod,
  selectedPriceItemPeriodId,
  selectedPriceItemPeriodTitle,
  periodPayFrequencyMonth,
  withPricePlanAlias = false,
}) => (
  <div className={styles.container}>
    <div className={styles.mainBlock}>
      <Amount
        selectedPriceItemPeriodId={selectedPriceItemPeriodId}
        currentPeriodId={currentPeriod?.id}
        withPricePlanAlias={withPricePlanAlias}
        periodPayFrequencyMonth={periodPayFrequencyMonth}
      />

      {currentPeriod?.id === selectedPriceItemPeriodId && <Discount />}
    </div>

    <NextDate selectedPriceItemPeriodTitle={selectedPriceItemPeriodTitle} />
  </div>
);

export default React.memo(TotalPriceBlock);
